import React, { FC, useMemo } from 'react';
import { SolutionAnswer } from '../../../../../../config/api/models/Solutions';
import { preProcessLatex } from '../../../../helpers';
import StudentAnswerChip from '../answers/StudentAnswerChip';
import { StyledQuestionTitle } from './Atoms';
import { useTranslation } from 'react-i18next';
import { MathJax } from 'better-react-mathjax';
import ReactHtmlParser from 'react-html-parser';

type StudentSolutionSubContentAnswersProps = {
  subContentQuestion?: string;
  answers: SolutionAnswer[];
  type: string;
  level: number;
};

export const StudentSolutionSubContentAnswers: FC<StudentSolutionSubContentAnswersProps> = ({
  subContentQuestion,
  answers,
  type,
  level,
}) => {
  const { t } = useTranslation();
  const allQuestionsAreEqual = useMemo(() => {
    let result: boolean = true;
    let firstQuestion: string;

    answers.forEach(answer => {
      if (firstQuestion == null) {
        firstQuestion = preProcessLatex(answer.question);
      } else if (preProcessLatex(answer.question) !== firstQuestion) {
        result = false;
      }
    });

    // if all answers except first are '', return true;
    if (
      answers.filter(
        answer =>
          !(
            preProcessLatex(answer.question) === firstQuestion ||
            preProcessLatex(answer.question) === ''
          )
      ).length === 0
    ) {
      result = true;
    }

    return result;
  }, [answers]);

  return answers.length > 0 ? (
    <div>
      {allQuestionsAreEqual && (
        <StyledQuestionTitle>
          {subContentQuestion == null ? (
            <>
              {answers[0].question == null ? (
                <>
                  {t(`trajectory.sections.shared.solutions.defaultQuestions.${type}`, {
                    defaultValue: t(
                      'trajectory.sections.shared.solutions.defaultQuestions.Undefined'
                    ),
                  })}
                </>
              ) : (
                <MathJax>{ReactHtmlParser(preProcessLatex(answers[0].question))}</MathJax>
              )}
            </>
          ) : (
            level !== 0 && <MathJax>{ReactHtmlParser(preProcessLatex(subContentQuestion))}</MathJax>
          )}
        </StyledQuestionTitle>
      )}
      {answers
        .filter(solutionAnswer => solutionAnswer.correct)
        .map((solutionAnswer, saIndex) => (
          <React.Fragment key={saIndex}>
            {allQuestionsAreEqual ? (
              <StudentAnswerChip answer={solutionAnswer.text} correct grey={false} />
            ) : (
              <StyledQuestionTitle>
                <MathJax>{ReactHtmlParser(preProcessLatex(solutionAnswer.question))}</MathJax>
                <StudentAnswerChip answer={solutionAnswer.text} correct grey={false} />
              </StyledQuestionTitle>
            )}
          </React.Fragment>
        ))}
    </div>
  ) : null;
};
